import { Component, OnInit, TemplateRef, ViewChild, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { DocumentoAsociarTarea, BaseControl, FuncionDocumento } from '@app/shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LocalDataSource } from 'ng2-smart-table';
import { ManageFunctionConfig } from './shared/manage-function.config';
import { ManageFunctionDataService } from './shared/manage-function.data.service';
import { ManageFunctionFormService } from './shared/manage-function.form.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-manage-function',
  templateUrl: './manage-function.component.html',
  styleUrls: ['./manage-function.component.scss'],
  providers: [ ManageFunctionFormService, ManageFunctionDataService ]
})
export class ManageFunctionComponent implements OnInit, OnDestroy {
  // Documento con las funciones
  @Input() document: DocumentoAsociarTarea;

  addFunction = false;

  listFunction: any[];
  // Configuracion de la tabla
  settings = {};
  // Contiene los documentos
  source: any = [];
  // Contiene los datos de la tabla previamente seteados y listos para renderizar en la tabla
  sourceData: LocalDataSource;
  // Controles del formulario
  controls: BaseControl<any>[] = [];
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al template de la modal
  @ViewChild('template') private template: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
   // Documento con las funciones
   @Output() saveFunction: EventEmitter<DocumentoAsociarTarea> = new EventEmitter();

  constructor(
    private modalService: BsModalService,
    private mffs: ManageFunctionFormService,
    private toastr: ToastrService,
    private mfds: ManageFunctionDataService) {}

  ngOnInit() {
    const funt = new ManageFunctionConfig();
    this.settings = funt.settings;
    funt.accion.subscribe((data: any) => {
      this.deleteFunction(data.row);
    });

    if (this.document) {
      this.loadinDocs();
    }

    this.mfds.getFunction().subscribe(res => {
      this.listFunction = res;
    });

  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Abre la modal
   *
   * @memberof ManageFunctionComponent
   */
  open() {
    this.modalRef = this.modalService.show(this.template, { class: 'modal-lg', backdrop: 'static' });
    this.ngOnInit();
  }

  /**
   * Cierra la modal
   *
   * @memberof ManageFunctionComponent
   */
  close(): void {
    this.saveFunction.emit(this.document);
    delete this.document;
    delete this.source;
    delete this.sourceData;
    this.modalRef.hide();
  }

  /**
   * Guarda la informacion del formulario y agrega la funcion
   *
   * @param {*} data
   * @memberof ManageFunctionComponent
   */
  sendedFunction(data: any) {
    let valid = true;
    for (let index = 0; index < this.document.funciones.length; index++) {
      if (this.document.funciones[index].id_funcion === data.cboFuncion) {
        this.toastr.warning('La función ya se encuentra agregada para este documento', 'Función duplicada');
        valid = false;
        break;
      }
    }
    if (valid) {
      for (let index = 0; index < this.listFunction.length; index++) {
        if (this.listFunction[index].id === data.cboFuncion) {
          const fun: FuncionDocumento = {
            id_funcion: data.cboFuncion,
            funcion: this.listFunction[index].nombre,
            obligatorio: data.chkObligatorio
          };
          this.document.funciones.push(fun);
          this.loadinDocs();
          this.addFunction = false;
          break;
        }
      }
    }
  }

  /**
   * Elimina la funcion seleccionada
   *
   * @param {FuncionDocumento} data
   * @memberof ManageFunctionComponent
   */
  deleteFunction(data: FuncionDocumento) {
    for (let index = 0; index < this.document.funciones.length; index++) {
      if (this.document.funciones[index].id_funcion === data.id_funcion) {
        this.document.funciones.splice(index, 1);
      }
    }
    this.loadinDocs();
  }

  /**
   * Carga o refresca los datos de la tabla
   *
   * @memberof ManageFunctionComponent
   */
  loadinDocs() {
    this.source = this.document.funciones;

    if (this.source) {
      this.source.forEach((element: any) => {
        if (element.obligatorio) {
          element['respuesta'] = 'Sí';
        } else {
          element['respuesta'] = 'No';
        }
      });
    }
    this.sourceData = new LocalDataSource(this.source);
    this.sourceData.refresh();
  }

  /**
   * Abre el formulario de agregar función al documento
   *
   * @memberof ManageFunctionComponent
   */
  openFormFuntion() {
    this.controls = this.mffs.getFormFunction(this.ngSelectTpl);
    this.addFunction = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/basic-process-configuration/manage-function/manage-function.component.ts